import React from 'react';
import { Text, StyleSheet } from 'react-native';
import IconMap from '../constants/IconMap';
import { FontSize } from '../styles';
import PropTypes from 'prop-types';
import { scale } from '../utils/scale.utils';

const Icon = ({ name, style, size, color }) => {
  const localStyle = {};

  if (Number.isInteger(size)) {
    localStyle['fontSize'] = scale(size, 0.3);
  }

  if (color) {
    localStyle['color'] = color;
  }

  return <Text style={[styles.icon, style, localStyle]}>{IconMap[name]}</Text>;
};

Icon.propTypes = {
  name: PropTypes.oneOf(Object.keys(IconMap)).isRequired,
  size: PropTypes.number,
  style: PropTypes.any,
  color: PropTypes.string,
};

const styles = StyleSheet.create({
  icon: {
    fontFamily: 'tripeasy',
    fontSize: FontSize.body,
    color: 'black',
  },
});

export default Icon;
